import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const VehicleList = Loadable(lazy(() => import('./VehicleList')));
const TrailorsList = Loadable(lazy(() => import('./TrailorsList')));
const Roadside = Loadable(lazy(() => import('./RoadsideInspections')));
const Trackvehicle = Loadable(lazy(() => import('./TrackVehicle')));
const AddVehicle = Loadable(lazy(() => import('./AddVehicle')));
const AddTrailor = Loadable(lazy(() => import('./AddTrailor')));

const VehicleRoutes = [
	{
		path: '/vehiclelist',
		element: <VehicleList />,
		auth: authRoles.admin,
	},
	{
		path: '/trailorslist',
		element: <TrailorsList />,
		auth: authRoles.admin,
	},
	{
		path: '/roadsideinspections',
		element: <Roadside />,
		auth: authRoles.admin,
	},
	{
		path: '/trackvehicle',
		element: <Trackvehicle />,
		auth: authRoles.admin,
	},
	{
		path: '/addvehicle',
		element: <AddVehicle />,
		auth: authRoles.admin,
	},
	{
		path: '/addtrailor',
		element: <AddTrailor />,
		auth: authRoles.admin,
	},
];

export default VehicleRoutes;
